import { buildMessages, type BuildMessagesProps } from "@eroad/i18n/buildMessages";
import phoenixComponentsTranslations from "@phoenix/components/translations";
import routeManagerTranslations from "@phoenix/domains/route-manager/translations";
import shareManagerTranslations from "@phoenix/domains/share-manager/translations";
import trackingTranslations from "@phoenix/domains/tracking/translations";
import unidentifiedDrivingTranslations from "@phoenix/domains/unidentified-driving/translations";

const translations: BuildMessagesProps = {
  frCA: {
    ...trackingTranslations.frCA,
    ...shareManagerTranslations.frCA,
    ...unidentifiedDrivingTranslations.frCA,
    ...routeManagerTranslations.frCA,
    ...phoenixComponentsTranslations.frCA,
  },
  enNZ: {
    ...trackingTranslations.enNZ,
    ...shareManagerTranslations.enNZ,
    ...unidentifiedDrivingTranslations.enNZ,
    ...routeManagerTranslations.enNZ,
    ...phoenixComponentsTranslations.enNZ,
  },
  enUS: {
    ...trackingTranslations.enUS,
    ...shareManagerTranslations.enUS,
    ...unidentifiedDrivingTranslations.enUS,
    ...routeManagerTranslations.enUS,
    ...phoenixComponentsTranslations.enUS,
  },
  enAU: {
    ...trackingTranslations.enNZ,
    ...shareManagerTranslations.enNZ,
    ...unidentifiedDrivingTranslations.enNZ,
    ...routeManagerTranslations.enNZ,
    ...phoenixComponentsTranslations.enNZ,
  },
};

const messages = buildMessages(translations);

export { messages };
